<template>
    <article class="flex flex-col gap-4">
        <!-- Question -->
        <div class="richtext richtext--lg richtext--tight js-richtext-video" v-html="question.question"></div>
        
        <!-- Question Audio Player -->
        <div class="grid gap-3" v-if="question.questionAudio != null">
            <QuizAudioPlayer
                :url="question.questionAudio.url"
                :transcript="question.questionAudioTranscript"
            />
        </div>

        <!-- Answers -->
        <div class="flex flex-col justify-start items-start gap-3">
            <button
                v-for="(a, i) in question.answers"
                :key="a.answerId"
                aria-role="button"
                type="button"
                :class="getClass(a.answerId)"
                :data-selected="selected == a.answerId"
                @click="handleSelection(a.answerId)"
            >
                <!-- Prefix -->
                <span class="">
                    <strong>{{ letters[i] }}.</strong>
                </span>

                <!-- Answer -->
                <div class="text-left" v-html="a.content"></div>
            </button>
        </div>
    </article>
</template>

<script setup>
    import { ref } from 'vue';
    import Icon from '../pieces/Icon.vue';
    import QuizAudioPlayer from './QuizAudioPlayer.vue';
    const emit = defineEmits(['selectAnswer']);
    const props = defineProps({
        question: null
    });

    const selected = ref(null);
    const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

    const handleSelection = (id) => {
        selected.value = id;
        getClass(id);
        emit('selectAnswer', props.question.questionId, id);
    };

    const getClass = (answerId) => {
        return [
            'inline-flex justify-start items-start gap-2 border rounded-md px-4 py-2 w-full transition-colors duration-200 hover:bg-blue-light-3',
            {
                '!bg-blue-light-2': selected.value == answerId
            }
        ];
    };
</script>
